var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"sign-in-page"},[_c('b-container',{staticClass:"p-0 m-0",attrs:{"fluid":""}},[(_vm.$route.name === 'shared.login')?_c('div',{staticClass:"col-12 col-sm-4 offset-sm-4 d-flex justify-content-center"}):_vm._e(),_c('div',{class:_vm.classObject},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }